import LicenseProto from "./license-proto"
import {License} from "../const/license"

export default class LicenseBusiness2023 extends LicenseProto {
    constructor(licenseUsers:number) {
        super(License.BUSINESS_2023);

        this.maxUsers           = 350
        this.maxAttachmentMb    = 500

        this.isPro              = true
        this.isBusiness         = true

        this.billingAndFinance  = true;
        this.maxStorage         = 'Unlimited'
        this.name               = 'Business'

        this.isPaid             = true

        this.licenseUsers       = licenseUsers ? licenseUsers : false
    }
}
